import { Navigate } from "react-router-dom"

import { useSelector } from "react-redux"

const RequireVerified = ({ children }) => {
   const isVerified = useSelector((state) => state.user?.is_email_or_phone_verified)

   if (isVerified === false) {
      return <Navigate to="/verify" replace />
   }

   return children
}

export default RequireVerified
